module.exports = "/_next/static/images/d6774768712dac74e6c66721a23f2165-pregnant-woman@mobile@2x.jpg.webp";